// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3rBZy","image":"Header_image__XBUW6","name":"Header_name__1wDOl","info":"Header_info__1JWGW","infoRow":"Header_infoRow__2Gs7u"};